module.exports = __webpack_public_path__ + "img/kreatino.29894592.jpg";